import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Button } from '@chakra-ui/react'
import { FaDownload } from 'react-icons/fa'

import { FormSubmittedActionItem } from '../types'
import { useDownloadClientFormPDF } from '~components/shared/actions/download-form'

interface Props {
    actionItem: FormSubmittedActionItem
    isSmall: boolean
}

export default function FormDownloadPDFAction({ actionItem, isSmall }: Props) {
    const { handleDownloadPDF, generating } = useDownloadClientFormPDF(
        actionItem.client_form,
    )

    return (
        <Button
            size={isSmall ? 'xs' : 'sm'}
            variant="outline"
            leftIcon={isSmall ? undefined : <Icon as={FaDownload} />}
            shadow="sm"
            onClick={handleDownloadPDF}
            isLoading={generating}
            isDisabled={!actionItem.client_form}
        >
            Download PDF
        </Button>
    )
}
